import BaseComponent from "../../../general/js/base-component";
import {EVENT_FIELD_VALIDATION_FAILED, EVENT_FIELD_VALIDATION_SUCCEEDED} from "./async-form.component";

const STATE_SUCCESS = 1;
const STATE_FAILED = 2;

export default class ValidationFieldset extends BaseComponent {
    constructor() {
        super(...arguments);

        this.state = null;

        this.onInnerFieldValidationFailed = this.onInnerFieldValidationFailed.bind(this);
        this.onInnerFieldValidationSucceed = this.onInnerFieldValidationSucceed.bind(this);
        this.init();
    }

    init() {
        this.element.addEventListener(EVENT_FIELD_VALIDATION_FAILED, this.onInnerFieldValidationFailed);
        this.element.addEventListener(EVENT_FIELD_VALIDATION_SUCCEEDED, this.onInnerFieldValidationSucceed);
    }

    onInnerFieldValidationFailed({field}) {
        if (this.state !== STATE_FAILED) {
            this.checkState(field);
        }
    }

    onInnerFieldValidationSucceed({field}) {
        if (this.state !== STATE_SUCCESS) {
            this.checkState(field);
        }
    }

    checkState(field) {
        let hasErrors = field.parent.fields.filter(field => this.element.contains(field.element)).some(field => {
            return field.validationResult !== true
        });
        let newState = hasErrors ? STATE_FAILED : STATE_SUCCESS;
        if (this.state !== newState) {
            this.updateState(newState);
        }
    }

    updateState(newState) {
        this.state = newState;
        switch (newState) {
            case STATE_SUCCESS:
                this.element.classList.remove('vf-has-error');
                this.element.classList.add('vf-is-success');
                break;
            case STATE_FAILED:
                this.element.classList.remove('vf-is-success');
                this.element.classList.add('vf-has-error');
                break;
        }
    }

    onDestroy() {
        this.element.removeEventListener(EVENT_FIELD_VALIDATION_FAILED, this.onInnerFieldValidationFailed);
        this.element.removeEventListener(EVENT_FIELD_VALIDATION_SUCCEEDED, this.onInnerFieldValidationSucceed);
    }
}



// WEBPACK FOOTER //
// ./app/components/form/js/validation-fieldset.component.js